exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px){.category-title[data-v-5d7311f2]{font-size:28px}}@media (max-width: 767px){.cms-box[data-v-5d7311f2]{text-align:justify}}.cms-box[data-v-5d7311f2] .change-consent{cursor:pointer}\n", ""]);

// exports
